import React, { useState, useEffect, useMemo } from 'react';
import { Alert, ScrollView, TouchableOpacity, View } from 'react-native'

import tw from '@/styles/tailwind';
import Text from '@/components/Text';
import Icon from '@/components/IcomoonIcon';
import { useForm } from 'react-hook-form';
import Input from '@/components/Forms/Input';
import IconButton from '@/components/IconButton';
import useFormSubmit from '@/hooks/useFormSubmit';
import BottomSheetModal from '@/components/BottomSheetModal';
import api from '@/utils/api';



import { useQuery } from '@tanstack/react-query';
import Select from '@/components/Forms/Select';
import BottomSheet from '@/components/BottomSheet';
import DateSelector from '@/components/Forms/DateSelector';
import FilePicker from '@/components/FilePicker';
import useActiveAdminCommunity from '@/hooks/useActiveAdminCommunity';
import DocumentPicker from '@/screens/Vinte/PaymentRequests/components/DocumentPicker';
import VinteExpenseTypeSelector from '@/screens/Vinte/components/VinteExpenseTypeSelector';




function CommunityBankAccountSelector({ control, name, communityId, setValue }) {
  const { isLoading, error, data: bankAccounts } = useQuery({
    queryKey: ['community.bank-accounts', communityId],
    queryFn: () => api.get(`/vinte/communities/${communityId}/bank-accounts`).then(response => response.data),
  })


  const options = useMemo(() => {
    const defaultValue = { value: "", label: "Sin definir" }

    const options = bankAccounts?.map(method => {
      return { value: method.uuid, label: method.name }
    })

    return options ? [...options] : []
  }, [bankAccounts])


  useEffect(() => {
    if (bankAccounts?.length == 1) {
      //!! De por sí tener que pasarle setValue a este componente es mala idea
      //!! tener que hacerlo en un timeout porque si se hace sincronicamente no cambia el valor
      //!! es un doble hack puerquísimo
      setTimeout(() => setValue(name, bankAccounts[0].uuid), 200)
    }
  }, [bankAccounts]);

  return (
    <Select
      control={control}
      name={name}
      placeholder={{ value: "", label: "Sin definir" }}
      items={options}
      rules={{}}
      style={{input: tw`bg-gray-100`}}
    />
  )
}



function AttributeRow({label, value}){
  return (
    <View style={tw`row justify-between`}>
      <Text style={tw`text-gray-700`}>{label}</Text>

      <Text style={tw`text-gray-400`}>{value}</Text>
    </View>
  )
}


function Currency({value, style}){

  function format(numero) {
    let partes = numero.toFixed(2).split('.');
    partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return partes.join('.');
  }

  const _value = format(value)

  return (
    <Text style={style}>${_value}</Text>
  )
}


function NewPaymentRequestForm({ onExpenseCreated, communityId, cfdi:_cfdi }){
  const { cfdi } = _cfdi

  const { control, handleSubmit, watch, setValue, reset } = useForm({
    defaultValues: {
      "provider_bank_account_id": "",
      "community_bank_account_id": "",
    }
  });

  const provider_bank_account_id = watch('provider_bank_account_id')

  const { submitForm, isSubmitting } = useFormSubmit({
    onSuccess: onExpenseCreated,
    onError: (error) => { },
    successToastMessage: "Solicitud registrada correctamente",
    method: "post",
    endpoint: `/vinte/communities/${communityId}/payment-requests`,
  })


  function _submitForm(data) {
    const _data = {
      ...data,
      apply_date: data.apply_date?.toISOString().slice(0, 10), // envia solo la fecha (YYYY-MM-DD)
      cfdi_id: cfdi.uuid,
    }

    submitForm(_data)
  }


  const providerBanksOptions = useMemo(() => {
    const defaultValue = { value: "", label: "Sin definir" }

    const options = cfdi.provider?.bank_accounts?.map(account => {
      const label = `${account.bank} - ${account.clabe}`
      return { value: account.uuid, label }
    })

    return options ? [...options] : []
  }, [cfdi.provider])


  useEffect(() => {
    if (cfdi.provider?.bank_accounts?.length == 1) {
      console.log("set_value", "provider_bank_account_id", cfdi.provider?.bank_accounts[0].uuid)
      setValue("provider_bank_account_id", cfdi.provider?.bank_accounts[0].uuid)
    }
  }, [cfdi.provider?.bank_accounts]);


  const selectedProviderBankAccount = useMemo(() => {
    if (provider_bank_account_id && cfdi.provider?.bank_accounts){
      return cfdi.provider.bank_accounts.find(e => e.uuid == provider_bank_account_id)
    }

    console.log({ provider_bank_account_id })
  }, [provider_bank_account_id]);



  console.log({ cfdi })





  //   {/* 
  //       //! Fecha contable
  //     */}
  //   <View style={tw``}>
  //     <Text style={tw`text-gray-500`}>Fecha contable</Text>

  //     <DateSelector control={control} name="apply_date" rules={{}} />
  //   </View>



  
  return (
    <View style={tw``}>
      <View style={tw`px-3 py-3`}>
        <Text style={tw`text-secondary`}>{cfdi?.cfdi_data?.receptor?.nombre}</Text>
        <Text style={tw`text-secondary`}>Solicitud de pago vía transferencia</Text>
      </View>


      {/* 
        Detalles
      */}
      <View style={tw`bg-white rounded-xl px-3 py-3 mb-5`}>
        <Text style={tw`text-center text-secondary border-b border-gray-200 font-500 -px-3 pb-2 mb-2`}>Detalles</Text>

        <AttributeRow label={"Tipo de soporte"} value={"Factura"} />


        {/* 
          Tipo de gasto
        */}
        <View style={tw`mb-3 mt-3`}>
          <Text style={tw`text-gray-700`}>Tipo de gasto</Text>

          <VinteExpenseTypeSelector control={control} setValue={setValue} name={"expense_type_id"} />
        </View>


        {/* Cuenta origen */}
        <View style={tw``}>
          <Text style={tw`text-gray-700`}>Cuenta origen</Text>

          <CommunityBankAccountSelector
            control={control}
            communityId={communityId}
            setValue={setValue}
            name={"community_bank_account_id"}
          />
        </View>



        {/* <AttributeRow label={"Número de solicitud"} value={"63"} /> */}


        {/* 
          Descripnción
        */}
        <View style={tw`mt-3`}>
          <Text style={tw`text-gray-700`}>Concepto</Text>

          <Input
            control={control}
            name='description'
            placeholder='ej: Arreglo de reja de entrada'
            rules={{ required: true }}
          />
        </View>
      </View>

      {/* 

        Datos cuenta destino

      */}
      <View style={tw`bg-white rounded-xl px-3 py-3 mb-5`}>
        <Text style={tw`text-center text-secondary border-b border-gray-200 font-500 -px-3 pb-2 mb-2`}>Datos cuenta destino</Text>

        <AttributeRow label={"A favor de"} value={cfdi.cfdi_data?.emisor?.nombre} />
        <AttributeRow label={"RFC"} value={cfdi.cfdi_data?.emisor?.rfc} />
        <AttributeRow label={"Tipo de proveedor"} value={cfdi.provider?.entity_type} />
        <AttributeRow label={"Persona"} value={cfdi.provider?.type} />
        {/* TODO */}
        <Text>Ver detalles del proveedor</Text>


        {/*---- Separador -----*/}
        <View style={tw`border-t border-b border-gray-200 pt-2 pb-2`}>
          <AttributeRow label={"Cantidad a pagar"} value={<Currency value={cfdi.cfdi_data?.monto_total} style={tw`text-base text-secondary font-500`} />} />

          <Text style={tw`text-sm text-gray-500`}>{cfdi.cfdi_data?.monto_total_letra}</Text>
        </View>


        {/* !!!! TODO:  */}
        <AttributeRow label={"Fecha"} value={"Lunes 22 de mayo 2025"} />
        <AttributeRow label={"Semana"} value={"29"} />


        {/* Seleccionar cuenta destino */}
        <Select
          control={control}
          name={"provider_bank_account_id"}
          placeholder={{ value: "", label: "Sin definir" }}
          items={providerBanksOptions}
          rules={{required: true}}
          style={{ input: tw`bg-gray-100`, wrapper: tw`mt-3 mb-1` }}
        />


        {/* Banco seleccionado */}
        <View style={tw``}>
          <AttributeRow label={"Banco"} value={selectedProviderBankAccount?.bank} />
          <AttributeRow label={"No. de cuenta"} value={selectedProviderBankAccount?.account_number} />
          <AttributeRow label={"CLABE"} value={selectedProviderBankAccount?.clabe} />
        </View>

        
      </View>


      {/* 
        Detalle CFDI
      */}
      <View style={tw`bg-white rounded-xl px-3 py-3 mb-5`}>
        <Text style={tw`text-center text-secondary border-b border-gray-200 font-500 -px-3 pb-2 mb-2`}>Facturación</Text>

        <AttributeRow label={"0002928353"} value={"✅"} />

        <View style={tw`row justify-between mt-3 mb-4 border-t border-b border-gray-200 py-3`}>
          <View style={tw`row`}>
            <Text style={tw`text-primary`}>9/6/2025</Text>
            <Text style={tw`text-primary ml-3`}>CFDI Válido</Text>
          </View>

          {/* <Text style={tw`text-primary`}>Detalles</Text> */}
        </View>

        {/* <View style={tw`bg-primary rounded-full items-center justify-between py-2 self-center px-5`}>
          <Text style={tw`text-base text-white`}>Validar Nuevamente</Text>
        </View> */}
        <View style={tw``}>
          {
            cfdi.validation_response?.detalleMensajes?.map(msg => 
              <Text style={tw`text-sm text-primary`}>
                <Icon name='check' color={tw.color('text-primary')} size={14} style={tw`mr-1`} />
                {msg}
              </Text>
            )
          }
        </View>
      </View>



      {/* 
        
      */}
      {/* <DocumentPicker
        onFileSelected={(file) => console.log("Newpaymentrequest", file)}
        // postUrl
        // acceptedMimes
        // extraData
      /> */}



      <IconButton
        title={isSubmitting ? "Generando..." : "Generar solicitud"}
        style={tw`self-center my-5`}
        disabled={isSubmitting}
        onPress={handleSubmit(_submitForm)}
      />
    </View>
  )
}



function StartRequestSection({ communityId, onCfdiSelected }){
  return (
    <View style={tw`flex-1 pt-5 px-5`}>
      <View style={tw`mb-4`}>
        <Text style={tw`mb-2 text-lg font-600 text-secondary`}>Nueva solicitud de pago</Text>
        <Text style={tw`mb-4 px-3 font-bold text-gray-500`}>Para empezar selecciona el XML o el ZIP del CFDI</Text>
      </View>

      {/*  */}
      <View style={tw``}>
        <DocumentPicker
          onFileSelected={data => {
            // console.log("onfileselected", data)
            // setValue('image_uid', file?.uuid)
            onCfdiSelected?.(data)
          }}
          label="Seleccionar comprobante"
          postUrl={`/vinte/payment-requests/pre-check`}
          acceptedMimes={[
            // "application/pdf", 
            "text/xml",
            "application/zip", "application/x-zip-compressed",
          ]}
          extraData={{
            community_id: communityId,
          }}
        />
      </View>
    </View>
  )
}


export default function NewPaymentRequestScreen({ route }) {
  const { communityId } = useActiveAdminCommunity()
  const [cfdi, setCfdi] = useState(null);

  const { onPaymentRequestCreated } = route.params

  // const datete = watch("apply_date")
  // console.log(datete, typeof datete);
  

  // useEffect(() => {
  //   if (visible) {
  //     reset({
  //       apply_date: new Date(),
  //     })
  //   } else {
  //     reset({})
  //   }
  // }, [visible])

  const onCfdiSelected = cfdi => {
    setCfdi(cfdi)
  }
  const _onPaymentRequestCreated = paymentRequest => {
    onPaymentRequestCreated?.(paymentRequest)
  }


  // bg-white
  return (
    <View style={tw`flex-1  h-full`}>
      {/* <MomoSelector /> */}


      {
        ! cfdi &&
          <StartRequestSection communityId={communityId} onCfdiSelected={onCfdiSelected} />
      }

      {
        cfdi &&
          <NewPaymentRequestForm
            onExpenseCreated={_onPaymentRequestCreated}
            communityId={communityId}
            cfdi={cfdi}
          /> 
      }
    </View>
  );
}
